import { render, staticRenderFns } from "./LegalePage.vue?vue&type=template&id=e0ebb71a&"
import script from "./LegalePage.vue?vue&type=script&lang=js&"
export * from "./LegalePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports